
import './hd.scss';

interface Props {
    onClose: () => void;
}

export default function HDXDMiniGame(props: Props) {
    const { onClose } = props;
    return (
        <>
            <div className="hdXD">
                <section className="hd-txcb">
                    <div className="wrapper">
                        <div className="title">HƯỚNG DẪN CHƠI</div>
                        <div className="close" onClick={onClose}>
                            <img src={require(`assets/images/txcanban/statis/close.png`)} alt='' />
                        </div>
                        <div className="inner">
                            <div className="tblBottomScroll">
                                <div className="content">
                                    <h3>Hướng Dẫn</h3>
                                    <div className="content-guide">
                                        <div className="content-guide-item">
                                            <span className="title-guide">Luật chơi</span>
                                            <ul>
                                                <li>Trò xóc đĩa là trò chơi đơn giản chỉ gồm có dụng cụ xóc đĩa và bàn cược.</li>
                                                <li>Dụng cụ xóc đĩa gồm có 1 cái bát, 1 cái đĩa và 4 đồng xu được phân biệt bởi 2 màu trắng và đỏ.</li>
                                            </ul>
                                        </div>
                                        <div className="content-guide-item">
                                            <span className="title-guide">TỈ LỆ CƯỢC</span>
                                            <ul>
                                                <li>Chẵn/Lẻ: <strong>1 : 0.96</strong></li>
                                                <li>4 Trắng / 4 Đỏ: <strong>1 : 14</strong></li>
                                                <li>3 Trắng / 3 Đỏ: <strong>1 : 2.9</strong></li>
                                            </ul>
                                        </div>
                                        <div className="content-guide-item">
                                            <span className="title-guide">Cách Chơi</span>
                                            <ul>
                                                <li>Chọn mức cược và đặt vào 1 hoặc nhiều ô để cược.</li>
                                                <li>Nhấn ‘Đặt Lại’ để lập lại cược.</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="line-guide"></div>
                                    <span className="title-guide">CÁC CỬA CƯỢC ĐỂ NGƯỜI CHƠI ĐẶT CƯỢC</span>
                                    <div className="content-guide">
                                        <div className="content-guide-item">
                                            <p>Cược Lẻ</p>
                                            <ul>
                                                <li>3 đồng xu màu trắng và 1 đồng xu màu đỏ.</li>
                                                <li>3 đồng xu màu đỏ và 1 đồng xu màu trắng.</li>
                                            </ul>
                                        </div>
                                        <div className="content-guide-item">
                                            <p>Cược Chẵn</p>
                                            <ul>
                                                <li>2 đồng xu màu đỏ và 2 đồng xu màu trắng</li>
                                                <li>4 đồng xu đều màu trắng hoặc 4 đồng xu đều màu đỏ</li>
                                            </ul>
                                        </div>
                                        <div className="content-guide-item">
                                            <p>Các cửa đặt cược đặc biệt</p>
                                            <ul>
                                                <li>4 đồng xu màu trắng.</li>
                                                <li>4 đồng xu màu đỏ.</li>
                                                <li>3 đồng xu màu trắng và 1 đồng xu màu đỏ.</li>
                                                <li>3 đồng xu màu đỏ và 1 đồng xu màu trắng.</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

        </>
    );
}
